import { OrgTypes } from '@mode/shared/contract-common';
import * as angular from 'angular';

/* eslint-disable */
class ColorPalettesDropdownController implements angular.IController {
  colorPalette: string;
  colorPalettes: ReadonlyArray<OrgTypes.ColorPalette>;
  dropupClass: boolean;
  updatePalette: any;
  selectPalette: any;
  paletteType: string;
  palettesLink: string;
  accordion: boolean;

  constructor() {}

  getCurrentThemeValue() {
    if (!this.colorPalette || !this.colorPalette.length) {
      return;
    }
    let colorPalette = this.colorPalettes.filter((palette) => {
      return palette.token === this.colorPalette;
    });
    return colorPalette.length ? colorPalette[0].value.split(',') : [];
  }

  getCurrentPalette() {
    if (!this.colorPalette || !this.colorPalette.length) {
      return;
    }
    let colorPalette = this.colorPalettes.filter((palette) => {
      return palette.token === this.colorPalette;
    });
    return colorPalette.length ? colorPalette[0] : undefined;
  }

  onSelectPalette(palette) {
    if (this.accordion) {
      this.selectPalette(palette);
    } else {
      this.updatePalette(palette);
    }
  }

  onUpdatePalette(palette) {
    this.updatePalette({ palette: palette });
  }

  showCustomPalettes() {
    return (
      this.colorPalettes &&
      this.colorPalettes.filter((palette) => {
        return !palette.predefined && palette.type === this.paletteType;
      }).length
    );
  }
}

export const ColorPalettesDropdownComponent: angular.IComponentOptions = {
  bindings: {
    colorPalette: '<',
    colorPalettes: '<',
    dropupClass: '<',
    updatePalette: '&',
    selectPalette: '&',
    paletteType: '<',
    palettesLink: '<',
    accordion: '<',
    showPalettesUpsell: '<',
  },
  template: `
    <div uib-dropdown ng-attr-dropdown-append-to-body="{{ctrl.accordion}}" class="advanced-theme" ng-class="{dropup: ctrl.dropupClass}">
      <a href="#" class="chart-toggle-container clearfix dropdown-toggle" uib-dropdown-toggle>
        <div href="#" class="chart-toggle-theme">
          <div class="theme-name">{{ctrl.getCurrentPalette().name}}</div>
          <i class="icon-double-carets pull-right"></i>
          <div class="divergent-gradient" ng-if="ctrl.getCurrentPalette().type === 'divergent'">
            <span style="background: linear-gradient(to right, {{ctrl.getCurrentPalette().value.split(',')[0]}}, {{ctrl.getCurrentPalette().value.split(',')[1]}}, {{ctrl.getCurrentPalette().value.split(',')[2]}} )"></span>
          </div>
        </div>
      </a>
      <ul uib-dropdown-menu class="dropdown-menu dropdown-menu-left advanced-theme" select-height="390">
        <div class="header" ng-if="ctrl.showCustomPalettes()">Custom Palettes</div>
        <li ng-if="ctrl.showCustomPalettes()" ng-repeat="colorPalette in ctrl.colorPalettes | filter: {type: ctrl.paletteType, predefined: false} track by $index">
          <a href="#" ng-class="{'active': colorPalette.token === ctrl.colorPalette}" class="checkbox-icon" ng-click="ctrl.onSelectPalette({palette: colorPalette})">
            <span class="selected-indicator"></span>
            <div class="palette-name">{{ colorPalette.name }}</div>
            <div class="swatches" ng-if="ctrl.getCurrentPalette().type === 'categorical'">
              <span class="swatch" ng-repeat="color in colorPalette.value.split(',') track by $index" ng-if="$index < 3" style="background:{{color}}"></span>
            </div>
            <div class="divergent-gradient" ng-if="ctrl.getCurrentPalette().type === 'divergent'">
              <span style="background: linear-gradient(to right, {{colorPalette.value.split(',')[0]}}, {{colorPalette.value.split(',')[1]}}, {{colorPalette.value.split(',')[2]}} )"></span>
            </div>
          </a>
        </li>
        <hr ng-if="ctrl.showCustomPalettes()" />
        <div class="header">Mode Default Palettes</div>
        <li ng-repeat="colorPalette in ctrl.colorPalettes | filter: {type: ctrl.paletteType, predefined: true} track by $index"
            data-test="color-palette-dropdown-{{colorPalette.name}}">
          <a ng-class="{'active': colorPalette.token === ctrl.colorPalette}" href="#" class="checkbox-icon" ng-click="ctrl.onSelectPalette({palette: colorPalette})">
            <span class="selected-indicator"></span>
            <div class="palette-name">{{ colorPalette.name }}</div>
            <div class="swatches" ng-if="ctrl.getCurrentPalette().type === 'categorical'">
              <span class="swatch" ng-repeat="color in colorPalette.value.split(',') track by $index" ng-if="$index < 3" style="background:{{color}}"></span>
            </div>
            <div class="divergent-gradient" ng-if="ctrl.getCurrentPalette().type === 'divergent'">
              <span style="background: linear-gradient(to right, {{colorPalette.value.split(',')[0]}}, {{colorPalette.value.split(',')[1]}}, {{colorPalette.value.split(',')[2]}} )"></span>
            </div>
          </a>
        </li>
        <div class="custom-upsell" ng-if="ctrl.showPalettesUpsell">
          + Or add a <a href="{{ctrl.palettesLink}}" target="_blank">custom palette here</a>
        </div>
      </ul>
    </div>
  `,
  controller: ColorPalettesDropdownController,
  controllerAs: 'ctrl',
};
